import StickyNote from './StickyNote';
export * from './StickyNote';
export default StickyNote;
